<template>
  <div class="fa-conversation-view">
    <div v-if="loading" style="padding: 20px; text-align: center;">
      <b-spinner/>
    </div>
    <template v-else>
      <!-- summary header -->
      <div class="fa-conv-summary">
        <div class="fa-conv-summary-row">
          <div class="fa-stat">
            <div class="fa-stat-label">Turns</div>
            <div class="fa-stat-value">{{ stats.turns }}</div>
          </div>
          <div class="fa-stat">
            <div class="fa-stat-label">Tokens</div>
            <div class="fa-stat-value">{{ formatTokens(stats.total_tokens) }}</div>
          </div>
          <div class="fa-stat">
            <div class="fa-stat-label">Cost</div>
            <div class="fa-stat-value">${{ stats.total_cost_dollars.toFixed(4) }}</div>
          </div>
          <div class="fa-stat">
            <div class="fa-stat-label">Tool calls</div>
            <div class="fa-stat-value">{{ stats.tool_calls }}</div>
          </div>
          <div class="fa-stat" v-if="stats.truncated > 0">
            <div class="fa-stat-label">Truncated turns</div>
            <div class="fa-stat-value" style="color: #b58100;">{{ stats.truncated }}</div>
          </div>
        </div>
        <div style="font-size: 12px; color: #888; margin-top: 6px;">
          <span v-if="sessionData.created_at">Created {{ formatEpoch(sessionData.created_at) }}</span>
          <span v-if="sessionData.updated_at"> · Updated {{ formatEpoch(sessionData.updated_at) }}</span>
          <span v-if="sessionData.archived_at"> · Archived {{ formatEpoch(sessionData.archived_at) }}</span>
        </div>
      </div>

      <!-- messages -->
      <!-- fullstory: fs-mask admin transcript review — full user conversations -->
      <FaConversationViewer :messages="messages" class="fs-mask"/>
    </template>
  </div>
</template>

<script>
import FaConversationViewer from './fa_conversation_viewer.vue'
import { formatEpoch, formatTokens } from '../../helpers/fa_admin'

export default {
  name: 'FaConversationView',
  components: { FaConversationViewer },
  props: {
    sessionData: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: false },
  },
  computed: {
    // flatten chat session turns into {role, content, model, tokens, cost,
    // tool_calls} rows. each turn yields one user + one assistant message.
    //
    // CM writes per-turn tokens/cost/model under turn.usage (see
    // OpenAIChatService.chat in fleet-int-api/external/openai_client.py).
    // fall back to top-level fields for any shape variant / future flatten.
    messages () {
      const turns = (this.sessionData && this.sessionData.turns) || []
      const out = []
      turns.forEach(t => {
        if (t.user) out.push({ role: 'user', content: t.user })
        if (t.assistant) {
          const u = (t && t.usage) || {}
          const inTok = Number(u.input_tokens != null ? u.input_tokens : (t.input_tokens || 0))
          const outTok = Number(u.output_tokens != null ? u.output_tokens : (t.output_tokens || 0))
          const cents = Number(u.estimated_cost_cents != null ? u.estimated_cost_cents : (t.estimated_cost_cents || 0))
          out.push({
            role: 'assistant',
            content: t.assistant,
            model: u.model || t.model || '',
            tokens: (inTok + outTok) || null,
            cost: cents / 100,
            tool_calls: t.tool_calls || [],
          })
        }
      })
      return out
    },
    stats () {
      const turns = (this.sessionData && this.sessionData.turns) || []
      let totalIn = 0, totalOut = 0, totalCents = 0, tools = 0, truncated = 0
      turns.forEach(t => {
        const u = (t && t.usage) || {}
        totalIn += Number(u.input_tokens != null ? u.input_tokens : (t.input_tokens || 0))
        totalOut += Number(u.output_tokens != null ? u.output_tokens : (t.output_tokens || 0))
        totalCents += Number(u.estimated_cost_cents != null ? u.estimated_cost_cents : (t.estimated_cost_cents || 0))
        tools += ((t.tool_calls || []).length)
        if (t.is_truncated) truncated += 1
      })
      return {
        turns: turns.length,
        total_tokens: totalIn + totalOut,
        total_cost_dollars: totalCents / 100,
        tool_calls: tools,
        truncated: truncated,
      }
    },
  },
  methods: {
    formatEpoch,
    formatTokens,
  },
}
</script>

<style scoped>
.fa-conversation-view { padding: 8px 0; }

.fa-conv-summary {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 14px;
}
.fa-conv-summary-row {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}
.fa-stat { min-width: 110px; }
.fa-stat-label {
  font-size: 11px;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.fa-stat-value {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-top: 2px;
}
</style>
